import { ApolloLink } from '@apollo/client';
import token from 'entities/token';

export const authMiddleware = new ApolloLink((operation, forward) => {
  const jwtToken = token.getIdToken()?.jwtToken;
  operation.setContext({
    headers: {
      ...(jwtToken ? { authorization: `Bearer ${jwtToken}` } : {}),
    },
  });
  return forward(operation);
});
